export const makeHitArea = (el) => {
  if (el) el.hitArea = new PIXI.Rectangle(0, 0, el.width /  el.scale.x, el.height /  el.scale.y);
};
